<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Refunds List" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <span>Start Date</span>
              <datepicker :upperLimit="upperLimitDate" v-model="fromDate" class="form-control"/>
            </div>
            <div class="col-md-4 user_role">
              <span>End Date</span>
              <datepicker :upperLimit="upperLimitDate" v-model="toDate" class="form-control"/>
            </div>
            <div class="col-md-4 user_plan">
              <label></label>
              <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>
            </div>
          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0">
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <SearchSelect
                      v-model="selectedStore"
                      @selectedFullObj="selectedFullObj"
                      url="v1/get-stores"
                      :extract-options="(res) => res.data?.stores || []"
                      placeholder="Search Store..."
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedTerminal">
                      <option :value="null">Select Terminal</option>
                      <option :key="index" :value="option" v-for="(option, index) in terminalData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="terminalLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedChannel">
                      <option :value="null">Select Channel</option>
                      <option :key="index" :value="option" v-for="(option, index) in channelData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="channelLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-between align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_role">
              <SelectOptions
                  label=""
                  selectAppend="account"
                  labelValue="currency.code"
                  v-model="selectedAccount"
                  :url="showSelectAccountOption"
                  :externalData="$store.getters.getAccountData"
              />
            </div>
<!--            <div class="col-md-4 user_status">-->
<!--              <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>-->
<!--            </div>-->
            <div class="col-md-4 user_status">
              <select class="form-control" v-model="recordStatus">
                <option :value="null">Select Status</option>
                <option v-for="(item, index) in recordStatusOptions" :key="index" :value="item.id">{{ item.value }}</option>
              </select>
            </div>
            <div class="col-md-4 user_status">
              <button type="button" class="btn btn-primary" @click="onSubmitFilters">Search</button>
              <button type="button" class="ml-2 btn btn-dark" @click="onClearFilters">Clear</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="">
            <div class="row">
            </div>
          </div>
          <CommonTable
              url="v1/get-all-refunds"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="mutedData"
              :filteredData="filteredData"
              customClass="table-hover-animation"
              :exportData="exportData"
              :hidePdfExportButton="true"
          />
        </div>
      </div>
    </div>
  </div>
  <DetailTextModal :show="showDescriptionModal" :text="description"
                   @hide="showDescriptionModal = false" />
  <RefundDetailsModal :show="showRefundDetailsModal" :data="refundRequestSelectedData"
                          :index="refundRequestSelectedIndex"
                          @hide="showRefundDetailsModal = false"

  />
  <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to cancel refund?"
                     title="Update Status"
                     :image="`${publicPath}images/confirm.png`" @hide="showConfirmationModal = false"></ConfirmationModal>
</template>

<script>
import {ref} from "vue";
import Datepicker from 'vue3-datepicker'
import SearchSelect from "@/components/common/SearchSelect.vue";
export default {
  components:{
    SearchSelect,
    Datepicker
  },
  mounted(){
    this.showSelectAccountOption = 'v1/get-wallet-list'
  },
  data(){
    return{
      recordStatus: null,
      recordStatusOptions: [
        { id: 0, value: "Pending" },
        { id: 1, value: "Initiated" },
        { id: 2, value: "Processed" },
        { id: 3, value: "Canceled" },
        { id: 4, value: "Rejected" },
      ],
      description:'',
      showDescriptionModal:false,
      toDate: null,
      fromDate: null,
      showConfirmationModal: false,
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'refunds',
          }

          if(this.toDate){
            requestData.toDate = this.formatDate(this.toDate)
          }
          if(this.fromDate){
            requestData.fromDate = this.formatDate(this.fromDate)
          }

          if(this.selectedStore){
            requestData.storeId = this.selectedStore.id
          }
          if(this.selectedTerminal){
            requestData.terminalId = this.selectedTerminal.id
          }
          if(this.selectedChannel){
            requestData.channelId = this.selectedChannel.id
          }

          if(this.selectedAccount){
            requestData.currencyId = this.selectedAccount.currency_id
          }
          if(this.search != ''){
            requestData.search = this.search
          }
          if(this.recordStatus != null){
            requestData.status = this.recordStatus
          }


          this.downloadReport(requestData)
        }
      },
      breadcrumb: [
        {name: 'App'},
        {name: 'Refunds'},
      ],
      showRefundDetailsModal: false,
      refundRequestSelectedData: null,
      refundRequestSelectedIndex: 0,
      tableHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'transaction_id',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-primary" style="cursor: pointer" title="Click For Details">${value}</span>`


            return  html


          },
          cta: (row) => {
            if(row.refunded_transaction && !this.isEmpty(row.refunded_transaction)){
              this.$router.push({name: 'transactions-details-with-id',params: {id:row.refunded_transaction.uuid}})
            }
            return null
          }
        },
        {
          title: 'Id',
          valueKey: 'uuid',
          html: true,
          alter: function(value,row) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              if (row.added_by && row.added_by_user) {
                if(row.added_by != row.user_id){
                  html = `
                <div class="row">
                <div class="col-12">
                <span class="text-primary ">${value}</span>
                </div><p><div class="badge badge-light-danger ml-1" style="margin-top: 0.3rem">${row.added_by_user.first_name+' '+row.added_by_user.last_name}</div></p></div>`
                }
              }
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: 'Reference Id',
          valueKey: 'reference_id',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-warning ">${value}</span>`
            else
              html = `<span class="text-dark ">N/A</span>`

            return  html


          }
        },
        {
          title: 'Status',
          valueKey: 'status_str',
          html: true,
          alter: function (value,obj){
            var html=''
            if(obj.status == 1)
              html = `<div class="badge badge-pill  badge-glow badge-success">${value}</div>`
            else if(obj.status == 3)
              html = `<div class="badge badge-pill  badge-glow badge-danger">${value}</div>`
            else
              html = `<div class="badge badge-pill  badge-glow badge-warning">${value}</div>`


            return html



          }
        },
        {
          title: "Description",
          valueKey: "description",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-success" style="cursor: pointer" title="click to view full description">${value.substring(0,12)+'...'}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.description = row.description
            this.showDescriptionModal = true
          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value)
              html = `<div  class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces
              )}</div>`

            if(row.refunded_transaction)
              html += `<div class="badge badge-light-success ml-sm-1">${row.refunded_transaction.currency.code}</div>`

            return  html


          }
        },
        {
          title: 'Channel',
          valueKey: 'refunded_transaction',
          html: true,
          alter: function (value, obj) {
            var html = ''
            if (value){
              if(value.channel)
                html = `<div class="badge badge-light-primary">${value.channel.name +'/'+value.channel.code}</div>`
            }


            return html
          }
        },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: 'Details',
          class: 'btn-primary mr-1',
          cta: (row, index) => {
            this.refundRequestSelectedData = row.details
            this.refundRequestSelectedIndex = index
            this.showRefundDetailsModal = true
          },

        },
        {
          title: 'Cancel',
            conditionalRendering: true,
            condition: (row)=>{
              if(row.status != 0){
                return false
              }
              return true
            },
          class: 'btn-danger',
          cta: (row,index) => {
            // this.cancelRefund(row, index)
            this.selectedRow = row
            this.selectedIndex = index
            this.showConfirmationModal = true
          }
        },
      ],
      mutedData: [],
      selectedRow: '',
      selectedIndex: '',
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
      showSelectAccountOption: '',
      showSelectTypesOption: '',
      selectedAccount: null,
      search: '',
      filteredData:{}

  }
  },
  methods:{
    selectedFullObj(obj){
      if(obj){
        this.terminalData = obj.terminals
      }else{
        this.terminalData = []
      }
    },
    confirm() {
      let row = this.selectedRow
      let index = this.selectedIndex
      let data = {
        refundId : row.id
      };
      if(row.status == 2){
        data.status = 1
      }else{
        data.status = 2
      }

      this.makeRequest('post', 'v1/cancel-refund-request', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.mutedData = {
              index: index,
              status_str : !(callResponse.response.data.data)? 'Canceled' : callResponse.response.data.data.status_str ,
              status: !(callResponse.response.data.data)  ? 3 : callResponse.response.data.data.status
            }
          }
        }

        this.showConfirmationModal = false

      });

    },
    formatDate(val){
      let date = new Date(val)
      let day = ("0" + date.getDate()).slice(-2)
      let month = ("0" + (date.getMonth() + 1)).slice(-2)
      let year= date.getFullYear()

      let formatted_date = year+'-'+month+'-'+day
      return formatted_date
    },
    onSubmitFilters() {
      let dataFiltered = {}

      if(this.toDate){
        dataFiltered.toDate = this.formatDate(this.toDate)
      }
      if(this.fromDate){
        dataFiltered.fromDate = this.formatDate(this.fromDate)
      }

      if(this.selectedStore){
        dataFiltered.storeId = this.selectedStore
      }
      if(this.selectedTerminal){
        dataFiltered.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        dataFiltered.channelId = this.selectedChannel.id
      }

      if(this.selectedAccount){
        dataFiltered.currencyId = this.selectedAccount.currency_id
      }
      if(this.search != ''){
        dataFiltered.search = this.search
      }
      if(this.recordStatus != null){
        dataFiltered.status = this.recordStatus
      }

      this.filteredData = dataFiltered


    },
    onClearFilters() {
      this.toDate = null
      this.fromDate = null
      this.selectedAccount = null
      this.recordStatus = null
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {}

    },
  },
  watch:{
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
      }
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      this.channelData = []
      if(val){
        this.channelData = val.channels
      }
    },
  }
}
</script>

